import { madridDateAddDays, madridToday } from '@/utils/madrid-date';
import type { DailyEarning } from '../types';

export type DayBucket = { date: string; count: number };
export type AxisLabel = { label: string; pct: number };

const BAR_W = 8;
const GAP = 4;

export function computeDayBuckets(
  daily: DailyEarning[],
  width: number
): DayBucket[] {
  if (width <= 0) return [];
  const n = Math.max(1, Math.floor(width / (BAR_W + GAP)));
  const byDate = new Map<string, number>();
  for (const d of daily) byDate.set(d.date.slice(0, 10), d.lead_count);
  const today = madridToday();
  const buckets: DayBucket[] = [];
  for (let i = n - 1; i >= 0; i--) {
    const iso = madridDateAddDays(today, -i);
    buckets.push({ date: iso, count: byDate.get(iso) ?? 0 });
  }
  return buckets;
}

export function computeDayAxisLabels(buckets: DayBucket[]): AxisLabel[] {
  if (buckets.length < 2) return [];
  const last = buckets.length - 1;
  const labels: AxisLabel[] = [];
  buckets.forEach((b, i) => {
    const d = new Date(b.date + 'T12:00:00');
    if (d.getDate() !== 1) return;
    labels.push({
      label: d.toLocaleDateString('es-ES', { month: 'short' }),
      pct: (i / last) * 100,
    });
  });
  return labels;
}
